module.exports = __webpack_public_path__ + "static/img/map-choose-bg.75f9e6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/map-choose-bg.png
// module id = 1jA6
// module chunks = 0